'use strict';

NewUserWizard.$inject = [
  '$state',
];

export function NewUserWizard($state) {

  let manager = null;
  // var states = {
  //  start: {
  //    state: {
  //      name: 'login'
  //    },
  //    actions: {
  //      login: {
  //        next: {
  //          name: 'home'
  //        }
  //      },
  //      signup: {
  //        next: {
  //          name: 'create_profile'
  //        }
  //      }
  //    }
  //  },
  //  create_profile: {
  //    state: {
  //      name: ''
  //    },
  //    actions: {
  //      submit: {
  //        next: 'org_home'
  //      }
  //    }
  //  }
  // };

  this.start = start;
  this.getResumePoint = getResumePoint;
  this.performAction = performAction;

  function start(wManager) {
    manager = wManager;
  }

  function resume(wManager) {
    manager = wManager;
  }

  /**
   * Return the state information needed to resume if the app is restarted
   * @param {string} actionName
   * @param {object} [actionParams=null]
   * @returns {{name: string, params: {object}}}
   */
  function getResumePoint(actionName, actionParams) {

  }

  function performAction(actionName, actionParams) {

  }
}



// WEBPACK FOOTER //
// ./src/js/auth/wizards/NewUserWizard.js